import { h } from "preact";

const defaultColor = {
  twoTone: {
    twoToneColor: "#57CFC7",
    color: "#fff"
  },
  white: {
    twoToneColor: "#fff",
    color: "#fff"
  },
  black: {
    twoToneColor: "#000",
    color: "#000"
  },
  purpleBlack: {
    twoToneColor: "#000",
    color: "#6621c0"
  }
};

const Logo = ({ footerLogoColor, width, height }) => {
  const logoColor = defaultColor[footerLogoColor];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 185 32"
      role="img"
    >
      <title>Humanitix logo</title>
      <g fill="none" fill-rule="nonzero">
        <path
          fill={logoColor.color}
          d="M16.446 18.45c-1.411 0-2.155-.75-2.155-2.168V12.64a.886.886 0 0 0-.254-.7.875.875 0 0 0-.696-.256H8.442a.875.875 0 0 0-.696.256.886.886 0 0 0-.254.7v3.643c0 1.417-.746 2.168-2.157 2.168h-3.18C.746 18.45 0 17.7 0 16.282V2.684C0 1.264.746.514 2.155.514h3.18c1.411 0 2.157.75 2.157 2.17V5.14c-.022.26.07.516.254.7a.875.875 0 0 0 .696.255h4.899a.875.875 0 0 0 .696-.255.886.886 0 0 0 .254-.7V2.684c0-1.42.744-2.17 2.155-2.17h3.18c1.41 0 2.157.75 2.157 2.17v13.598c0 1.417-.746 2.168-2.157 2.168h-3.18zM30.517 18.745c-3.443 0-5.19-1.584-5.19-4.705V2.684c0-1.42.746-2.17 2.157-2.17h2.924c1.41 0 2.157.75 2.157 2.17v8.893c0 1.219.895 1.36 1.571 1.36.682 0 1.364-.05 2.039-.148a.906.906 0 0 0 .65-.306.917.917 0 0 0 .228-.685V2.684c0-1.42.746-2.17 2.157-2.17h2.96c1.411 0 2.155.75 2.155 2.17v13.598c0 1.417-.744 2.168-2.155 2.168h-1.608c-1.034 0-1.697-.272-2.083-.857l-.074-.11a.853.853 0 0 0-.659-.408.907.907 0 0 0-.47.152 16.308 16.308 0 0 1-6.759 1.518zM71.452 18.45c-1.411 0-2.157-.75-2.157-2.168V7.386c0-.937-.413-1.324-1.424-1.324h-.529a5.808 5.808 0 0 0-1.008.084.99.99 0 0 0-.803 1.062v9.074c0 1.417-.746 2.168-2.157 2.168h-2.633c-1.412 0-2.155-.75-2.155-2.168V7.386c0-.913-.453-1.324-1.464-1.324-.473-.008-.946.017-1.416.075a.978.978 0 0 0-.878 1.064v9.081c0 1.417-.746 2.168-2.155 2.168H49.78c-1.411 0-2.157-.75-2.157-2.168V2.684c0-1.42.746-2.17 2.157-2.17h1.499c.908 0 1.536.22 1.944.687l.138.207c.156.247.365.505.705.505a.975.975 0 0 0 .46-.139A11.839 11.839 0 0 1 60.599.01c1.756 0 3.048.48 3.851 1.43.175.23.442.37.729.382.209-.01.41-.08.581-.201C67.372.53 69.23 0 71.452 0 74.8 0 76.5 1.657 76.5 4.926v11.356c0 1.417-.747 2.168-2.158 2.168h-2.89zM84.929 18.964c-1.688 0-3.209-.442-4.284-1.27a4.503 4.503 0 0 1-1.782-3.727v-1.83c0-2.789 2.225-4.521 5.811-4.521H89.9c.659 0 .659-.525.659-.697v-.331c-.046-1.19-.792-1.397-2.34-1.397a205.3 205.3 0 0 0-5.925.11h-.088c-1.277 0-2.02-.753-2.21-2.236-.094-.592.048-1.199.398-1.686.365-.47.906-.767 1.496-.823C84.6.226 87.325.04 90.055 0c5.528 0 7.784 2.108 7.784 7.283v8.962a2.138 2.138 0 0 1-.62 1.584 2.114 2.114 0 0 1-1.574.623H93.67c-.74 0-1.425-.342-1.668-.834l-.147-.256c-.13-.294-.31-.356-.44-.356a.545.545 0 0 0-.333.135c-1.569 1.21-3.638 1.823-6.153 1.823zm2.567-8.086c-.976 0-1.608.534-1.608 1.361v.587c0 .663.46 1.362 1.755 1.362a15.304 15.304 0 0 0 2.221-.187.835.835 0 0 0 .74-.883v-1.421c0-.53-.279-.81-.805-.81l-2.303-.01zM115.09 18.45c-1.41 0-2.154-.75-2.154-2.168V7.386c0-.926-.461-1.324-1.537-1.324-.778-.008-1.556.03-2.33.117-.595.093-.878.442-.878 1.029v9.074c0 1.417-.746 2.168-2.157 2.168h-2.93c-1.411 0-2.157-.75-2.157-2.168V2.684c0-1.42.746-2.17 2.157-2.17h1.576c.75-.028 1.47.299 1.946.883l.108.143c.139.278.412.461.72.484.192-.009.38-.065.546-.164C110.4.64 112.69 0 114.617 0c3.684 0 5.554 2.152 5.554 6.4v9.887c0 1.417-.746 2.167-2.157 2.167l-2.923-.004z"
        />
        <rect
          width="7.2"
          height="17.935"
          x="123.498"
          y=".514"
          fill={logoColor.color}
          rx="2.153"
        />
        <path
          fill={logoColor.twoToneColor}
          d="M141.348 18.45c-1.41 0-2.157-.709-2.157-2.053V7.755h-3.606c-1.512 0-2.313-.75-2.313-2.17V2.685c0-1.42.801-2.17 2.313-2.17h14.412c1.514 0 2.313.75 2.313 2.17v2.902c0 1.419-.799 2.169-2.313 2.169h-3.606v8.642c0 1.344-.746 2.053-2.157 2.053h-2.886zM179.898 18.496c-.593 0-1.181-.267-1.756-.792l-3.37-3.119-3.378 3.119c-.57.525-1.159.792-1.756.792s-1.18-.267-1.755-.792l-2.31-2.132c-.56-.519-.848-1.055-.848-1.59 0-.533.287-1.07.849-1.59l3.419-3.145-3.406-3.143c-.562-.52-.85-1.055-.85-1.59 0-.537.288-1.071.85-1.592l2.309-2.13c.568-.525 1.156-.792 1.742-.792.586 0 1.18.267 1.756.792l3.375 3.119 3.38-3.119c.568-.525 1.156-.792 1.755-.792.6 0 1.183.267 1.756.792l2.306 2.13c.564.52.85 1.055.85 1.591s-.286 1.07-.85 1.591l-3.414 3.143 3.403 3.145c.564.52.85 1.055.85 1.59 0 .537-.286 1.071-.85 1.59l-2.306 2.132c-.568.525-1.159.792-1.751.792z"
        />
        <rect
          width="7.2"
          height="17.935"
          x="154.823"
          y=".514"
          fill={logoColor.twoToneColor}
          rx="2.153"
        />
        <path
          fill={logoColor.twoToneColor}
          d="M161.382 32c-1.09 0-2.179-.068-3.26-.203a2.383 2.383 0 0 1-1.649-.989 2.45 2.45 0 0 1-.397-1.918l.333-1.575a2.435 2.435 0 0 1 2.638-1.93c.775.092 1.555.138 2.335.138 4.359 0 8.533-1.479 10.64-3.767a2.404 2.404 0 0 1 2.945-.468l1.446.816a2.437 2.437 0 0 1 .658 3.701C173.73 29.676 167.87 32 161.382 32z"
        />
      </g>
    </svg>
  );
};

export default Logo;
